module.exports = __webpack_public_path__ + "img/county-durham-logo.6833ddc9.png";